import { SavedFeedbackListActionType } from '@modules/savedFeedbackList/store/savedFeedbackListActionType';
import { useSavedFeedbackListStore } from '@modules/savedFeedbackList/store/useSavedFeedbackListStore';
import { getSavedItemsMap } from '@modules/savedFeedbackList/utils';
import {
  AnalysisViewFragment,
  IndexTypeKeywordSummary,
  SavedFeedbackMetadataInput,
} from 'generated/graphql';
import { useDeepCompareEffect } from 'react-use';

interface UseUpdateSavedFeedbackStoreWithMetadataProps {
  analysis: AnalysisViewFragment | undefined;
}

export const useUpdateSavedFeedbackStoreWithMetadata = ({
  analysis,
}: UseUpdateSavedFeedbackStoreWithMetadataProps) => {
  const dispatch = useSavedFeedbackListStore(({ dispatch }) => dispatch);

  useDeepCompareEffect(() => {
    if (!analysis?.metadataV2?.collection?.savedFeedbackMetadata) {
      return;
    }
    const savedItems: SavedFeedbackMetadataInput[] =
      analysis.metadataV2?.collection?.savedFeedbackMetadata?.map(
        (metadata) => ({
          feedbackID: metadata.feedbackID,
          isFeedbackSaved: metadata.isFeedbackSaved,
          snippetMetadataV2: metadata.snippetMetadataV2?.map((snippet) => ({
            location: {
              keywordSummary: {
                endIdx: 0,
                startIdx: 0,
                msgIdx:
                  (snippet.location as IndexTypeKeywordSummary)?.msgIdx ?? 0,
                labelID:
                  (snippet.location as IndexTypeKeywordSummary)?.labelID ?? '',
              },
            },
          })),
        }),
      );

    dispatch({
      type: SavedFeedbackListActionType.INIT,
      payload: {
        savedCollectionAnalysis: {
          id: analysis.id,
          viewToken: analysis.viewToken,
          editToken: analysis.editToken,
          context: analysis.context,
          createdBy: analysis.createdBy,
        },
        savedItemsMap: getSavedItemsMap(savedItems),
        sortedSavedItems: savedItems,
      },
    });
  }, [analysis]);
};
